{
  "data-verbiage": {
    "siteName": "YourCompany",
    "breadcrumb": [
      { "label": "Crezia App Demo", "href": "#" },
      { "label": "Risk Assessment", "href": "#" }
    ],
    "hero": {
      "eyebrow": "Opportunity Assessment",
      "title": "Opportunity Assessment",
      "description": "Identify performance gaps, security vulnerabilities, and inefficiencies in your operations. Get actionable insights to future-proof your data infrastructure.",
      "primaryAction": "Build my use case",
      "secondaryAction": "Start a chat"
    },
    "header": {
      "crmLink": "Open CRM Page"
    },
    "footer": {
      "copyright": "© {year} Crezia Inc. All rights reserved. · v{version}"
    }
  },
  "loremIpsum": {
    "siteName": "Lorem Ipsum",
    "breadcrumb": [
      { "label": "Lorem ipsum", "href": "#" },
      { "label": "Dolor sit amet", "href": "#" }
    ],
    "hero": {
      "eyebrow": "Lorem ipsum / Dolor sit",
      "title": "Lorem Ipsum Dolor",
      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.",
      "primaryAction": "Lorem ipsum",
      "secondaryAction": "Dolor sit"
    },
    "header": {
      "crmLink": "Open CRM Page"
    },
    "footer": {
      "copyright": "© {year} Crezia Inc. All rights reserved. · v{version}"
    }
  },
  "manufacturing": {
    "siteName": "YourCompany",
    "breadcrumb": [
      { "label": "Crezia App Demo", "href": "#" },
      { "label": "Manufacturing", "href": "#" }
    ],
    "hero": {
      "eyebrow": "Manufacturing / Operations",
      "title": "Manufacturing Operations",
      "description": "Identify new product opportunities, capacity expansion levers, and optimization wins across your manufacturing operations. Get actionable insights to scale your production with confidence.",
      "primaryAction": "Build my use case",
      "secondaryAction": "Start a chat"
    },
    "header": {
      "crmLink": "Open CRM Page"
    },
    "footer": {
      "copyright": "© {year} Crezia Inc. All rights reserved. · v{version}"
    }
  }
}
